module.exports = __webpack_public_path__ + "static/media/ic-menu.3e989de0.svg";